import { useTheme } from '@mui/material/styles';

const useLayout = () => {
  const theme = useTheme();

  const APP_BAR_MOBILE = 10;
  const APP_BAR_DESKTOP = 12;

  return {
    flexGrow: 1,
    overflow: 'auto',
    marginTop: 'env(safe-area-inset-top) !important',
    marginBottom: 'env(safe-area-inset-bottom) !important',
    px: { xs: 1, sm: 1.5, md: 2, lg: 2.5, xl: 3 },
    paddingTop: APP_BAR_MOBILE,
    paddingBottom: '8px',
    [theme.breakpoints.up('sm')]: {
      paddingTop: APP_BAR_MOBILE + 3
      // paddingBottom: theme.spacing(2)
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: APP_BAR_MOBILE + 3
      // paddingBottom: theme.spacing(3)
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: APP_BAR_DESKTOP + 3,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
      // paddingBottom: theme.spacing(4)
    },
    transition: theme.transitions.create('margin', {
      duration: theme.transitions.duration.complex
    })
  };
};

export default useLayout;
